import React from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import LinkedInLogo from "../assets/LinkedInLogo";
import TwitterLogo from "../assets/TwitterLogo";
import salesagentDotAiLogo from "../assets/salesagentDotAiLogo.png";
import { useNavigate } from "react-router-dom";
import xSocialMediaIcon from "../assets/xSocialMediaBlackIcon.png";

const Footer = () => {
  const { isMobile } = useWindowDimensions();

  const navigate = useNavigate();

  const openCalendly = () => {
    const url = "https://calendly.com/fogteams/30min";
    window.open(url, "_blank");
  };

  return (
    <footer className="flex flex-col px-4 sm:px-20 sm:pt-7 bg-[#f3f3f3]">
      <div className="sm:flex w-full text-base py-6 items-start">
        <div className="flex flex-col pl-4 sm:pl-0 sm:items-start sm:text-left gap-4">
          <div className="font-medium mt-8 sm:mt-2 sm:mb-4 ">Get Started</div>

          <div
            onClick={openCalendly}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Book a demo
          </div>
          <div
            onClick={() => {
              navigate("/joinwaitlist");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Express Interest
          </div>
        </div>

        <div className="sm:ml-auto flex flex-col pl-4 sm:pl-0 sm:items-start sm:text-left gap-4">
          <div className="font-medium mt-8 sm:mt-2 sm:mb-4 ">Industries</div>

          <div
            onClick={() => {
              navigate("/industries/bfsi");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            BFSI
          </div>
          <div
            onClick={() => {
              navigate("/industries/automotive");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Automotive
          </div>
          {/* <div
            onClick={() => {
              navigate("/industries/edtech");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            EdTech
          </div> */}
        </div>
        <div className="sm:ml-[10rem] flex flex-col pl-4 sm:pl-0 sm:items-start sm:text-left gap-4">
          <div className="font-medium mt-8 sm:mt-2 sm:mb-4">Use Cases</div>
          <div
            onClick={() => {
              navigate("/use_case/hidden_revenue");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Unlock Hidden Revenue
          </div>
          <div
            onClick={() => {
              navigate("/use_case/lead_qualification");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Sales Lead Qualification
          </div>
          <div
            onClick={() => {
              navigate("/use_case/scheduling");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Physical Visit Scheduling With Address
          </div>
          <div
            onClick={() => {
              navigate("/use_case/cash_collection");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Cash Collection
          </div>
          <div
            onClick={() => {
              navigate("/use_case/nps");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            NPS With Advanced Analytics
          </div>
          <div
            onClick={() => {
              navigate("/use_case/renewals");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Renewals
          </div>
        </div>
        <div className="sm:ml-[5.7rem] flex flex-col pl-4 sm:pl-0 sm:items-start sm:text-left gap-4">
          <div className="font-medium mt-8 sm:mt-2 sm:mb-4">Resources</div>
          <div
            onClick={() => {
              navigate("/security");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Security
          </div>
          <div
            onClick={() => {
              navigate("/compliance");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Compliance
          </div>
          <div
            onClick={() => {
              navigate("/crisis_management");
            }}
            className="hover:text-blue-600 cursor-pointer text-sm">
            Crisis Management
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5 sm:flex-row w-full text-base py-6 justify-center sm:justify-start items-center">
        <img
          className={`${
            isMobile ? "w-[13rem]" : "w-[18rem]"
          } mx-0 pl-2 sm:pl-0 sm:mx-0`}
          src={salesagentDotAiLogo}
          alt=""
        />
        <div className="sm:ml-auto flex gap-4 sm:gap-5 items-center">
          <div
            onClick={() => {
              window.open(
                "https://x.com/salesagents_ai?s=11&t=zvBmvu6jvdLD7YkL9tQi2g",
                "_blank",
              );
            }}
            className="cursor-pointer">
            <img src={xSocialMediaIcon} className="w-[22px] h-[22px]" alt="" />
          </div>
          <div
            onClick={() => {
              window.open(
                "https://www.linkedin.com/company/salesagents-ai",
                "_blank",
              );
            }}
            className=" cursor-pointer">
            <LinkedInLogo />
          </div>
        </div>
      </div>
      <hr />
      <div className="flex flex-col sm:flex-row w-full text-base py-6 px-4 sm:px-0 items-center sm:items-center">
        <span className="text-center">
          &copy; {new Date().getFullYear()} SalesAgents AI. All rights
          reserved.
        </span>
        <div
          onClick={() => {
            navigate("/termsnconditions");
          }}
          className="mt-12 sm:mt-0 sm:ml-auto cursor-pointer">
          Terms & Conditions
        </div>
        <div className="bg-[#5322FF] opacity-20 h-[6px] w-[6px] mx-4 rounded-full my-2 sm:my-0"></div>

        <div
          onClick={() => {
            navigate("/cookiepolicy");
          }}
          className="cursor-pointer">
          Cookie Policy
        </div>
        <div className="bg-[#5322FF] opacity-20 h-[6px] w-[6px] mx-4 rounded-full my-2 sm:my-0"></div>

        <div
          onClick={() => {
            navigate("/privacypolicy");
          }}
          className="cursor-pointer">
          Privacy Policy
        </div>
      </div>
    </footer>
  );
};

export default Footer;
